"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const eggs_1 = require("@/common/eggs");
const material_ui_confirm_1 = require("material-ui-confirm");
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const _1 = require(".");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const isLeaderBlocked = (0, react_redux_1.useSelector)((state) => state.roomData.is_leader_block_user);
    const isOrderActive = (0, react_redux_1.useSelector)((state) => state.roomData.is_order_active);
    const whoAmI = (0, react_redux_1.useSelector)((state) => state.whoAmI);
    const roomId = (0, react_redux_1.useSelector)((state) => state.roomData.id);
    const isQuestion = (0, react_redux_1.useSelector)((state) => state.roomData.is_question);
    const leader = (0, react_redux_1.useSelector)((state) => state.roomData.leader);
    const activeSlotCount = (0, react_redux_1.useSelector)((state) => state.roomData.channel_activate_slot_count);
    const [isPending, setIsPending] = (0, react_1.useState)(false);
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const applyCommission = () => __awaiter(this, void 0, void 0, function* () {
        (0, functions_1.tempDisableClick)(1000);
        if (leader === whoAmI.id)
            (0, eggs_1.preventMyself)({ confirm, message: t('스스로 신청하지 말아요') });
        else if (isQuestion)
            window.location.href = `/room/${roomId}/inquiry-create`;
        else {
            setIsPending(true);
            yield (0, api_1.postData)(`/api/v1/room/${roomId}/inquiry`, {})
                .then(res => {
                window.location.href = `/room/inquiry/${res.data.result.inquiry_id}`;
            })
                .catch(error => {
                const { status } = error.response;
                if (status === 400)
                    (0, _1.handleCommissionApply400Error)({ error, confirm });
                else if (status === 403)
                    (0, errors_1.handle403Error)(error);
                else
                    alert((0, errors_1.commonErrorMsg)());
            })
                .finally(() => setIsPending(false));
        }
    });
    const goToLogin = () => (window.location.href = (0, string_utils_1.loginReturnPath)());
    const AvailableSlot = () => ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { padding: '0 10px 14px', fontSize: '16px', fontWeight: 'bold', textAlign: 'center' } }, { children: `${t('현재 가능 슬롯')} ${5 - activeSlotCount}${t('개')}` })));
    if (isLeaderBlocked) {
        return ((0, jsx_runtime_1.jsx)(OrderButtonWrapper, { children: (0, jsx_runtime_1.jsx)(components_1.MapleStoryButton, Object.assign({ isClosed: true }, { children: t('작가님과 대화가 필요해요!') })) }));
    }
    if (!isOrderActive) {
        return ((0, jsx_runtime_1.jsx)(OrderButtonWrapper, { children: (0, jsx_runtime_1.jsx)(components_1.MapleStoryButton, Object.assign({ isClosed: true }, { children: t('지금은 신청받지 않아요') })) }));
    }
    if (!whoAmI.is_logged_in) {
        return ((0, jsx_runtime_1.jsxs)(OrderButtonWrapper, { children: [(0, jsx_runtime_1.jsx)(AvailableSlot, {}), (0, jsx_runtime_1.jsx)(components_1.MapleStoryButton, Object.assign({ onClick: goToLogin }, { children: t('로그인하기') }))] }));
    }
    return ((0, jsx_runtime_1.jsxs)(OrderButtonWrapper, { children: [(0, jsx_runtime_1.jsx)(AvailableSlot, {}), (0, jsx_runtime_1.jsx)(components_1.MapleStoryButton, Object.assign({ disabled: isPending, onClick: applyCommission }, { children: isPending ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "inherit", thickness: 8 })) : ((0, jsx_runtime_1.jsx)("span", { children: t('신청하기') })) }))] }));
}
exports.default = default_1;
const OrderButtonWrapper = styled_1.default.div `
  position: sticky;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 14px 16px 40px;
  border-radius: 20px 20px 0 0;
  margin-top: 80px;
  background-color: white;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
`;
